import * as Types from '../../generated/index'

import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'
const defaultOptions = {} as const
export type JurnodesUsersQueryVariables = Types.Exact<{ [key: string]: never }>

export type JurnodesUsersQuery = {
  jurnodesUsers?: { collection: Array<{ id: number; name: string }> } | null
}

export const JurnodesUsersDocument = gql`
  query jurnodesUsers {
    jurnodesUsers {
      collection {
        id
        name
      }
    }
  }
`

/**
 * __useJurnodesUsersQuery__
 *
 * To run a query within a React component, call `useJurnodesUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useJurnodesUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJurnodesUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useJurnodesUsersQuery(
  baseOptions?: Apollo.QueryHookOptions<JurnodesUsersQuery, JurnodesUsersQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<JurnodesUsersQuery, JurnodesUsersQueryVariables>(
    JurnodesUsersDocument,
    options
  )
}
export function useJurnodesUsersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<JurnodesUsersQuery, JurnodesUsersQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<JurnodesUsersQuery, JurnodesUsersQueryVariables>(
    JurnodesUsersDocument,
    options
  )
}
export function useJurnodesUsersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<JurnodesUsersQuery, JurnodesUsersQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<JurnodesUsersQuery, JurnodesUsersQueryVariables>(
    JurnodesUsersDocument,
    options
  )
}
export type JurnodesUsersQueryHookResult = ReturnType<typeof useJurnodesUsersQuery>
export type JurnodesUsersLazyQueryHookResult = ReturnType<typeof useJurnodesUsersLazyQuery>
export type JurnodesUsersSuspenseQueryHookResult = ReturnType<typeof useJurnodesUsersSuspenseQuery>
export type JurnodesUsersQueryResult = Apollo.QueryResult<
  JurnodesUsersQuery,
  JurnodesUsersQueryVariables
>
